import { render } from "./LeadFailed.vue?vue&type=template&id=7af00f17"
import script from "./LeadFailed.vue?vue&type=script&lang=js"
export * from "./LeadFailed.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__